(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vastraversee-responsive-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vastraversee-banner-slider')) {
    customElements.define('vastraversee-banner-slider', class extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-banner-slide]'));
        if (this.slides.length < 2) return;

        this.currentSlide = 0;
        this.interval = Math.min(5000, Math.max(3000, Number(this.dataset.interval) || 4000));
        this.pauseButton = this.querySelector('[data-banner-pause]');
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.isPaused = false;
        this.onVisibilityChange = () => document.hidden ? this.stop() : this.start();
        this.onMotionChange = () => this.reducedMotion.matches ? this.stop() : this.start();
        this.onPauseClick = () => {
          this.isPaused = !this.isPaused;
          this.pauseButton.setAttribute('aria-label', this.isPaused ? 'Play banner slideshow' : 'Pause banner slideshow');
          this.pauseButton.title = this.isPaused ? 'Play banner slideshow' : 'Pause banner slideshow';
          this.pauseButton.querySelector('span').textContent = this.isPaused ? '▶' : 'Ⅱ';
          if (this.isPaused) this.stop();
          else this.start();
        };

        this.pauseButton.addEventListener('click', this.onPauseClick);
        document.addEventListener('visibilitychange', this.onVisibilityChange);
        this.reducedMotion.addEventListener('change', this.onMotionChange);
        this.start();
      }

      disconnectedCallback() {
        this.stop();
        if (this.pauseButton && this.onPauseClick) this.pauseButton.removeEventListener('click', this.onPauseClick);
        if (this.onVisibilityChange) document.removeEventListener('visibilitychange', this.onVisibilityChange);
        if (this.reducedMotion && this.onMotionChange) this.reducedMotion.removeEventListener('change', this.onMotionChange);
      }

      start() {
        if (this.timer || this.isPaused || document.hidden || this.reducedMotion.matches) return;
        this.timer = window.setInterval(() => this.showNext(), this.interval);
      }

      stop() {
        window.clearInterval(this.timer);
        this.timer = null;
      }

      showNext() {
        this.slides[this.currentSlide].hidden = true;
        this.slides[this.currentSlide].setAttribute('aria-hidden', 'true');
        this.currentSlide = (this.currentSlide + 1) % this.slides.length;
        this.slides[this.currentSlide].hidden = false;
        this.slides[this.currentSlide].setAttribute('aria-hidden', 'false');
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
